import React, { useState, useEffect, useContext } from "react";
import { Form, Radio } from "antd";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useGenders, usePatientStatus } from "../../hooks";
import RestrictedContext from "../util/RestrictedContext";

const RadioButtonItem = (props) => {
  const {
    name,
    category,
    required,
    genders,
    patientStatuses,
    employeeStatuses,
    visitsStrategy,
    todoDueDate,
    trueFalse,
    translated,
    identfierId,
    onChange,
    disabled,
    initialValue,
  } = props;
  const restricted = useContext(RestrictedContext);
  const [selectData, setSelectData] = useState([]);
  const allGenders = useGenders();
  const allPatientStatuses = usePatientStatus();
  useEffect(() => {
    let list = null;
    if (genders && allGenders.length > 0) {
      list = allGenders;
    } else if (patientStatuses && allPatientStatuses.length > 0) {
      list = allPatientStatuses;
    }
    if (list) {
      setSelectData(list);
    }
  }, [allGenders, allPatientStatuses, genders, patientStatuses]);

  useEffect(() => {
    let list = null;
    if (employeeStatuses) {
      list = [
        {
          id: 1,
          name: "active",
        },
        {
          id: 2,
          name: "not_active",
        },
        {
          id: 3,
          name: "candidate",
        },
      ];
    } else if (visitsStrategy) {
      list = [
        {
          id: "professional",
          name: "professionalEmployee",
        },
        {
          id: "controller",
          name: "controller",
        },
        {
          id: "alternate",
          name: "alternately",
        },
      ];
    } else if (todoDueDate) {
      list = [
        {
          id: "all",
          name: "all",
        },
        {
          id: "lastTwoWeeks",
          name: "lastTwoWeeks",
        },
        {
          id: "today",
          name: "today",
        },
        {
          id: "nextWeek",
          name: "nextWeek",
        },
      ];
    } else if (trueFalse) {
      list = [
        {
          id: true,
          name: "yes",
        },
        {
          id: false,
          name: "no",
        },
      ];
    }

    if (list) {
      setSelectData(list);
    }
  }, [employeeStatuses, visitsStrategy, trueFalse]);

  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);
  const identfier = identfierId ? identfierId : "id";
  return (
    <Form.Item
      name={name}
      rules={rules}
      label={label}
      initialValue={initialValue}
      disabled={true}
    >
      <Radio.Group
        onChange={onChange}
        disabled={!restricted["hasWritePermission"] || disabled}
      >
        {selectData.map((item, i) => (
          <Radio key={i} value={item[identfier]}>
            {translated
              ? intl.formatMessage({
                  id: "app.dataSelect." + name + "." + item.name,
                })
              : trueFalse
              ? intl.formatMessage({
                  id: "app.dataSelect." + item.name,
                })
              : item.name}
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
  );
};

RadioButtonItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export default RadioButtonItem;
